export const GET_DEALERS_REQUEST = 'GET_DEALERS_REQUEST';
export const GET_DEALERS_SUCCESS = 'GET_DEALERS_SUCCESS';
export const GET_DEALERS_FAILURE = 'GET_DEALERS_FAILURE';

export const SET_DEALERS = "SET_DEALERS";
export const SET_DEALER = "SET_DEALER";

export const SUBMIT_DEALER_REQUEST = 'SUBMIT_DEALER_REQUEST';
export const SUBMIT_DEALER_SUCCESS = 'SUBMIT_DEALER_SUCCESS';
export const SUBMIT_DEALER_FAILURE = 'SUBMIT_DEALER_FAILURE';

export const DELETE_DEALER_REQUEST = 'DELETE_DEALER_REQUEST';
export const DELETE_DEALER_SUCCESS = 'DELETE_DEALER_SUCCESS';
export const DELETE_DEALER_FAILURE = 'DELETE_DEALER_FAILURE';

export const getDealersRequest = (filters = {}) => ({
    type: GET_DEALERS_REQUEST,
    payload: {
        filters
    }
});

export const getDealersSuccess = (dealers, total = 0, companies = []) => ({
    type: GET_DEALERS_SUCCESS,
    payload: {
        dealers,
        companies,
        total
    }
});

export const getDealersFailure = err => ({
    type: GET_DEALERS_FAILURE,
    error: err
});

export const setDealers = (dealers = [], total = 0) => ({
    type: SET_DEALERS,
    payload: {
        dealers,
        total
    }
});

export const setDealer = (dealer = {}) => ({
    type: SET_DEALER,
    payload: {
        dealer
    }
});

export const submitDealerRequest = dealer => ({
    type: SUBMIT_DEALER_REQUEST,
    payload: {
        dealer
    }
});

export const submitDealerSuccess = dealer => ({
    type: SUBMIT_DEALER_SUCCESS,
    payload: {
        dealer
    }
});

export const submitDealerFailure = err => ({
    type: SUBMIT_DEALER_FAILURE,
    error: err
});

export const deleteDealerRequest = dealer => ({
    type: DELETE_DEALER_REQUEST,
    payload: {
        dealer
    }
});

export const deleteDealerSuccess = dealer => ({
    type: DELETE_DEALER_SUCCESS,
    payload: {
        dealer
    }
});

export const deleteDealerFailure = err => ({
    type: DELETE_DEALER_FAILURE,
    error: err
});
